module.exports = __webpack_public_path__ + "static/media/PlatziConf.72066261.png";